import { quickSearch } from "@/services/API.js";

import { Logger } from "aws-amplify"
const logger = new Logger("Global Search / MIXIN")

export const search = {
  computed: {
    currentRoute() {
      return this.$route.path; 
    }
  },
  methods: {
    quickSearch(payload, path) {
      return new Promise(async (res, rej) => {
        try {
          const search = await quickSearch(payload);
          
          if (search.Result) {
            window.EventBus.$emit('closeAdvancedSearch');
            this.$store.commit('setQuickSearchResults', {
              type: payload.category, 
              res: search,
            });
            this.$store.commit('setQuickSearchPayload', payload);

            if(this.currentRoute == path && this.currentRoute != '/search-results') {
              this.$router.push({ name: 'Search Results'})
            }
            res(search);
          }
          else {
            rej(search)
          }
        }
        catch {
          rej(search)
        }
      });
    },

    async fullSearch(payload, paginationInfo) {
      const allResults = [];
      const pageSize = paginationInfo.pageCount;

      for (let i = 0; i < pageSize; i++) {
        try {
          payload.pageNum = i + 1;

          const search = await quickSearch(payload);
          logger.info('search', search.Result)
          if (!search) {
            throw new Error(`Request failed`);
          }
          const data = await search.Result;

          if (Array.isArray(data)) {
            allResults.push(...data);
          } else {
            throw new Error(`Result is not array ${search.Result}`);
          }
        } catch (error) {
          throw new Error(`Error during API call ${i + 1}:`, error);
        }
      }
      logger.info('all results', allResults)
      return allResults;
    }
  }
}